import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "separateBlock sepLine" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "separateBlock__left ovalLeft" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "separateBlock__rigth ovalRight" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}